import { RootState } from "../store/store";


export const selectedNotifications = (state:RootState) => state.notifications.notifications